import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type SnackbarTypes = 'success' | 'warning' | 'error' | 'information';

export interface SnackbarState {
  open: boolean;
  type: SnackbarTypes;
  textContent: string;
  copyToClipboard?: boolean;
  requestID?: string;
}

const initialState: SnackbarState = {
  open: false,
  type: 'information',
  textContent: '',
  copyToClipboard: false,
  requestID: '',
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setSnackbar: (
      state,
      action: PayloadAction<{
        open: boolean;
        type?: SnackbarTypes;
        textContent?: string;
        copyToClipboard?: boolean;
        requestID?: string;
      }>
    ) => {
      state.open = action.payload.open;
      state.type = action.payload.type ?? state.type;
      state.textContent = action.payload.textContent ?? state.textContent;
      state.copyToClipboard = action.payload.copyToClipboard;
      state.requestID = action.payload.requestID;
    },
  },
});

export const { setSnackbar } = snackbarSlice.actions;

export const selectSnackbar = (state: { snackbar: SnackbarState }) => state.snackbar;

export default snackbarSlice.reducer;
